<template>
  <div class="main" v-title data-title="活动展示">
    <!-- <img src="http://123.56.170.62:9999/static/bg/banner5.png" alt /> -->
    <div class="content">
      <AllHeader title="活动展示"></AllHeader>
      <NewsList fenlei="活动展示"></NewsList>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue"
import NewsList from "@/components/NewsList.vue"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {}
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {},
  components: {
    AllHeader,
    NewsList,
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  img {
    width: 100%;
    height: 400px;
  }
  .content {
    padding-top: 20px;
    width: 810px;
    margin: 0px auto;
  }
}
</style>
